import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { MB_ACADEMIC_DEGREE_NORMALIZER, MbAcademicDegreesAdapter } from '../connectors'
import { pluck } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class MbOccAcademicDegreesAdapter implements MbAcademicDegreesAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load () {
    return this.http.get(this.getEndpoint()).pipe(
      pluck('academicDegrees'),
      this.converter.pipeable(MB_ACADEMIC_DEGREE_NORMALIZER)
    )
  }

  protected getEndpoint () {
    return this.occEndpoints.buildUrl('academicDegrees')
  }
}
